(function () {
  function $(sel, root = document) { return root.querySelector(sel); }
  function $all(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }
  function toInt(v, fallback = 0) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function getMainQty() {
    // 1) try normal quantity input
    const qtyInput = $('form[action*="/cart/add"] input[name="quantity"]');
    if (qtyInput) return Math.max(1, toInt(qtyInput.value, 1));

    // 2) fallback: try to read “Buy 1/2/3” selected radio (adjust selector if needed)
    const checked = $('input[type="radio"]:checked');
    if (checked && toInt(checked.value, 0) > 0) return toInt(checked.value, 1);

    return 1;
  }

  function getMainVariantId() {
    const idInput = $('form[action*="/cart/add"] input[name="id"]');
    return idInput ? toInt(idInput.value, 0) : 0;
  }

  function getSelectedUpsellVariantId() {
    // Shrine upsell element becomes selected via data-selected="true"
    const selected = $('.js-product-upsell[data-selected="true"]');
    if (!selected) return 0;
    return toInt(selected.getAttribute('data-id'), 0);
  }

  async function addItems(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  // Intercept product form submit
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    const upsellId = getSelectedUpsellVariantId();
    if (!upsellId) return; // no upsell selected → let default happen

    const mainId = getMainVariantId();
    if (!mainId) return;

    const qty = getMainQty();

    e.preventDefault();
    e.stopPropagation();

    try {
      await addItems([
        { id: mainId, quantity: qty },
        { id: upsellId, quantity: qty }
      ]);

      // If theme uses cart drawer
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:open'));
    } catch (err) {
      console.error('[Upsell Qty Sync]', err);
      form.submit(); // fallback
    }
  }, true);
})();